"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CordCreditProviderService = void 0;
const fetch_client_1 = require("./fetch-client");
class CordCreditProviderService extends fetch_client_1.FetchClient {
  constructor(baseUrl) {
    if (CordCreditProviderService.instance) {
      return CordCreditProviderService.instance;
    }
    super();
    if (baseUrl) {
      this.baseUrl = baseUrl;
    }
    CordCreditProviderService.instance = this;
  }
  getCreditProviderProcessingTimes() {
    return this.get('creditProviders/processingTimes');
  }
  updateCreditProviderProcessingTimes(creditProviderId, data) {
    return this.put('creditProviders/' + creditProviderId + '/processingTimes', data);
  }
  getTenantProcessingTimes() {
    return this.get('tenantProcessTimes');
  }
  updateTenantProcessingTimes(data) {
    return this.post('tenantProcessTimes', data);
  }
}
exports.CordCreditProviderService = CordCreditProviderService;
CordCreditProviderService.instance = null;
